import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { InputLabel, Typography } from '@material-ui/core';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineDot } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%'
      },
    oppositeContent: {
        flex: 0,
        padding:0,
    },
}))

export default function OperationTimeline(props) {
    const { orderOperationHistoryList } = props;    
  
    const classes = useStyles();
    const {t} = useTranslation('editOrder');    

    return (
        <React.Fragment>
            <Timeline>
            {
                orderOperationHistoryList.map((item, index)=>(
                    <TimelineItem key={index}>
                        <TimelineOppositeContent
                            className={classes.oppositeContent}
                            color="textSecondary"
                        >
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                        <TimelineDot />
                        <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <Paper elevation={3} className={classes.paper}>
                                <Typography variant="body2">
                                    {item.description}({item.operator})
                                </Typography>
                                {
                                    item.memo &&
                                    <Typography variant="body2" style={{width: 240, overflowWrap: 'anywhere'}}>
                                        "{item.memo}"
                                    </Typography>
                                }
                                <Typography variant="body2">
                                    {moment.unix(item.utc_add_time).format("YYYY-MM-DD HH:mm:ss")}
                                </Typography>
                            </Paper>                                    
                        </TimelineContent>
                    </TimelineItem>
                ))
            }                        
            </Timeline>
        </React.Fragment>
    )
}

OperationTimeline.defaultProps = {
    orderOperationHistoryList: []
}
